export default __webpack_public_path__ + "static/media/2_title.b39e57f1.png";